import { render, staticRenderFns } from "./Portata.vue?vue&type=template&id=6f42903c"
import script from "./Portata.vue?vue&type=script&lang=js"
export * from "./Portata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_2cae27f83758b46b73a9745eca16177c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports